import { render, staticRenderFns } from "./area-select.vue?vue&type=template&id=ade21a24&scoped=true&"
import script from "./area-select.vue?vue&type=script&lang=ts&"
export * from "./area-select.vue?vue&type=script&lang=ts&"
import style0 from "./area-select.vue?vue&type=style&index=0&id=ade21a24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade21a24",
  null
  
)

export default component.exports